import { render, staticRenderFns } from "./campaign_management.vue?vue&type=template&id=62d5f83d&"
import script from "./campaign_management.vue?vue&type=script&lang=js&"
export * from "./campaign_management.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports